import { render } from "./VMSCleanupForm.vue?vue&type=template&id=6dbbd92c&ts=true"
import script from "./VMSCleanupForm.vue?vue&type=script&lang=tsx"
export * from "./VMSCleanupForm.vue?vue&type=script&lang=tsx"

import "./VMSCleanupForm.vue?vue&type=style&index=0&id=6dbbd92c&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__